var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTickMarkAlt = function SvgTickMarkAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5547 1.1475C12.3039 0.910308 11.9083 0.921312 11.6711 1.17208L4.06564 9.21281L1.5757 6.0315L1.51344 5.96294C1.29253 5.75312 0.945419 5.73113 0.69831 5.92454C0.426489 6.13728 0.378602 6.5301 0.591349 6.80192L3.50802 10.5284L3.55272 10.5777C3.55786 10.5835 3.56312 10.5893 3.56851 10.5951L3.57028 10.597L3.57105 10.5977C3.57852 10.6056 3.58623 10.6132 3.59419 10.6208C3.84496 10.858 4.24053 10.847 4.47773 10.5962L12.5793 2.03105L12.6378 1.95929C12.8125 1.70966 12.7826 1.36314 12.5547 1.1475Z",
    fill: "white"
  })));
};
export default SvgTickMarkAlt;